const INITIAL_STATE = {
  linkOpenDate: '',
  scrollPosition: 0,
  scheduleDates: ['2026-07-23', '2026-07-24', '2026-07-25', '2026-07-26', '2026-07-27'],
  GPCRScheduleDates: ['2024-11-15', '2024-11-16', '2024-11-17'],
  GICScheduleDates: ['2026-03-24', '2026-03-25', '2026-03-26'],
  GIC4ScheduleDates: ['2026-09-08', '2026-09-09', '2026-09-10'],
};

const state = () => INITIAL_STATE;

const mutations = {
  setLinkOpenDate(state, newLinkOpenDate) {
    state.linkOpenDate = newLinkOpenDate;
  },
  setScrollPosition(state, newScrollPosition) {
    state.scrollPosition = newScrollPosition;
  },
};

const actions = {
  setLinkOpenDate(context, linkOpenDate) {
    context.commit('setLinkOpenDate', linkOpenDate);
  },
  setScrollPosition(context, scrollPosition) {
    context.commit('setScrollPosition', scrollPosition);
  },
};

const getters = {
  linkOpenDate(state) {
    return state.linkOpenDate;
  },
  scrollPosition(state) {
    return state.scrollPosition;
  },
  scheduleDates(state) {
    return state.scheduleDates;
  },
  GPCRScheduleDates(state) {
    return state.GPCRScheduleDates;
  },
  GICScheduleDates(state) {
    return state.GICScheduleDates;
  },
  GIC4ScheduleDates(state) {
    return state.GIC4ScheduleDates;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
